import { ApiFailure, request, type FileRef } from '@buildiary/core';

export { ApiFailure, request };

/** True when the app answers every request in the browser (VITE_MOCK=1). */
export const MOCK = import.meta.env.VITE_MOCK === '1';

/** Uploads one file (photo, audio, PDF) through POST /api/files (multipart, field "file"). */
export async function upload(file: Blob, name = 'file'): Promise<FileRef> {
  const fd = new FormData();
  fd.append('file', file, (file as File).name || name);
  return request('POST /api/files', {}, '', { body: fd });
}

/** Local object URLs for files uploaded in this session (mock mode and instant previews). */
const local = new Map<string, string>();
export function rememberFile(id: string, url: string): void {
  local.set(id, url);
}

/** Public pages (client and supplier links) read files with their link token: /api/files/<id>?link=<token>. */
let publicLink: string | null = null;
export function setPublicLink(token: string | null): void {
  publicLink = token;
}

/** Where to load a stored file from, or null when there is nothing to show (demo photos without a file). */
export function fileSrc(id: string | null | undefined): string | null {
  if (!id) return null;
  const l = local.get(id);
  if (l) return l;
  if (MOCK) return null;
  return `/api/files/${encodeURIComponent(id)}${publicLink ? `?link=${encodeURIComponent(publicLink)}` : ''}`;
}

/** A plain-language message for an error from request(). */
export function errorText(e: unknown, fallback = 'Something went wrong.'): string {
  if (e instanceof ApiFailure) return e.body.message || fallback;
  if (e instanceof Error && e.message) return e.message === 'Failed to fetch' ? 'No connection to the server. Check the internet and try again.' : e.message;
  return fallback;
}

export function fieldErrors(e: unknown): Record<string, string> {
  return e instanceof ApiFailure ? (e.body.fields ?? {}) : {};
}
